module.exports = new __parcel__URL__("project-summary-skeleton.tpl.f2232e71.svg").toString();